export const DEFAULT_TEMPLATES_PAGESIZE = 16;
export const DEFAULT_CAMPAIGNS_PAGESIZE = 10;
export const MAX_RECIPIENTS = 5;
export const DEFAULT_WHITELIST_URL = "https://www.venzapeak.com/support/public_resources/phishing/whitelist/#/";
export const CAMPAIGN_STATUS_STYLES: Record<string, { background: string; color: string }> = {
    Scheduled: { background: "#EAEAEB", color: "#000" },
    Live: { background: "#F0EFFD", color: "#6B5AED" },
    Testing: { background: "#FEF6E9", color: "#000" },
    Draft: { background: "#FEF6E9", color: "#000" },
    Complete: { background: "#CDE7CF", color: "#2E7D32" },
    Cancelled: { background: "#FBEAEA", color: "#D32F2F" },
    Failed: { background: "#FBEAEA", color: "#D32F2F" },
};
export const DIFFICULTY_COLOR: Record<string, { bg: string; color: string }> = {
    Beginner: { bg: "#CDE7CF", color: "#2E7D32" },
    Intermediate: { bg: "#FEF6E9", color: "#000" },
    Advanced: { bg: "#FBEAEA", color: "#D32F2F" },
};
export const DESKTOP_STEPS : string[] = [
    "Scenario",
    "Test Configuration",
    "Full Campaign Recipients",
    "Delivery & Schedule",
    "Review & Start Test"
];

export const MOBILE_STEPS : string[] = [
    "Scenario",
    "Test",
    "Recipients",
    "Delivery",
    "Review",
];

export const CAMPAIGN_LENGTH_LIST: { value: number, label: string }[] = [
    { value: 1, label: "1 day" },
    { value: 2, label: "2 days" },
    { value: 3, label: "3 days" },
    { value: 4, label: "4 days" },
    { value: 5, label: "5 days" },
    { value: 6, label: "6 days" },
    { value: 7, label: "7 days" },
    { value: 8, label: "8 days" },
    { value: 9, label: "9 days" },
    { value: 10, label: "10 days" }
]

export const ROLE_DESCRIPTION: Record<string, string> = {
    "superadmin": "Global administrators with full system-wide permissions.",
    "admin": "Those overseeing system and strategy",
    "cyber security": "Those overseeing system and strategy",
    "manager": "Department and property managers",
    "user": "All users other than Managers and Leadership team",
};